import { render, staticRenderFns } from "./DeleteBrandOfferPopup.vue?vue&type=template&id=069cb358&scoped=true&"
import script from "./DeleteBrandOfferPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteBrandOfferPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteBrandOfferPopup.vue?vue&type=style&index=0&id=069cb358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069cb358",
  null
  
)

export default component.exports